module.exports = __webpack_public_path__ + "static/media/sec2_banner_parking.e0937066.png";